import * as actions from "../actionTypes"

// pageDocs is { first: <doc>, last: <doc> } for that page, and used by prev/next
const initialState = {
  value: {
    page: 0,
    order: "desc",
    orderBy: "created",
    centre_id: "",
    checklist_template_id: actions.BLANK_SELECT_VALUE,
    completed: "",
    allocated: "",
  },
}

export default function checkListInstanceGridPagination(
  state = initialState,
  action
) {
  switch (action.type) {
    case actions.SET_CHECK_LIST_INSTANCE_GRID_PAGINATION: {
      return {
        ...state,
        value: action.payload.value,
      }
    }

    default:
      return state
  }
}
